import { render, staticRenderFns } from "./DPagination.vue?vue&type=template&id=4d93c00a&scoped=true&"
import script from "./DPagination.vue?vue&type=script&lang=js&"
export * from "./DPagination.vue?vue&type=script&lang=js&"
import style0 from "./DPagination.vue?vue&type=style&index=0&id=4d93c00a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93c00a",
  null
  
)

export default component.exports